import styled from "styled-components";

import theme from "../../utils/theme";

export const InputContainer = styled.div<{ $extraStyle?: string }>`
	.MuiFormControl-root {
		margin: 0;
		padding: 0;
		width: 100%;

		.MuiFormLabel-root {
			font-size: 14px;
			margin-top: 3px;
			margin-left: -2px;
		}

		.MuiInputBase-root {
			font-size: 13px;
			vertical-align: center;

			input {
				padding-top: 11px;
				padding-bottom: 11px;
			}
		}
	}

	position: relative;

	width: 100%;

	max-width: 295px;

	display: flex;

	margin-left: 0px;
	margin-bottom: 20px;

	${(props) => props.$extraStyle};
`;
